<script setup lang="ts">
const chatStore = useChatStore();

const { assistantForm, assistantAsk } = useAssistant();

const bus = useEventBus<string>("main");

const showTyping = ref(chatStore.awaitingReply);

const send = async () => {
  // Send message
  assistantAsk(assistantForm.message);
  // Clear input
  assistantForm.message = "";
};

watch(
  () => chatStore.awaitingReply,
  (value) => {
    if (value) {
      // Wait a second before showing the typing bubble
      window.setTimeout(() => {
        // Check if still waiting on response
        if (chatStore.awaitingReply) {
          // Show typing bubble
          showTyping.value = true;
          // Fire updated event
          bus.emit("chat:updated");
        }
      }, 1000);
    } else {
      showTyping.value = false;
    }
  },
);
</script>

<template>
  <div class="chat-window">
    <ChatMessages
      :messages="chatStore.messages"
      :typing="showTyping"
      class="messages"
    />
    <ChatControls
      v-model="assistantForm.message"
      class="controls"
      @send="send"
    />
  </div>
</template>

<style lang="scss" scoped>
.chat-window {
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  overflow: hidden;
}

.messages {
  flex-grow: 1;
}
</style>
